import { Helmet, HelmetProvider } from 'react-helmet-async';
import favicon from '../imagenes/logoutm.png'
import FiltrarVisitasDirectas from '../componentes/FiltrarVisitasDirectas';

const VisitasDirectas = () => {
    return (
        <>
            <HelmetProvider>
                <div>
                    <Helmet>
                        <link rel="shortcut icon" href={favicon} type="image/x-icon"/>
                        <title>Registro de Visitas - Sistema de Administración Museo UTM</title>
                    </Helmet>
                </div>
            </HelmetProvider>

            <FiltrarVisitasDirectas />
        </>
    );
}

export default VisitasDirectas; 